import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ShopSection from "../components/homeComponents/ShopSection";
import Loading from "../components/LoadingError/Loading";
import Message from "../components/LoadingError/Error";
import BreadcrumbNav from "../components/homeComponents/BreadcrumbNav";
import CategoryAccordionNav from "../components/homeComponents/CategoryAccordionNav";
import { listStoreCategories } from "../Redux/Actions/CategoryActions";
import axios from "../http";
import "../screens/styles/catalog-products-page.css";

const CatalogProductsPage = ({ match }) => {
  const dispatch = useDispatch();

  const categorySlug = match?.params?.categorySlug || match?.params?.slug || "";
  const departmentSlug = match?.params?.departmentSlug || "";
  const pageNumber = match?.params?.pageNumber || 1;

  const [departments, setDepartments] = useState([]);
  const [departmentLoading, setDepartmentLoading] = useState(false);
  const [departmentError, setDepartmentError] = useState(null);

  const categoryStoreList = useSelector((state) => state.categoryStoreList);
  const { loading, error, categories = [] } = categoryStoreList || {};

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(listStoreCategories());
  }, [dispatch, categorySlug, departmentSlug, pageNumber]);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        setDepartmentLoading(true);
        setDepartmentError(null);

        const { data } = await axios.get("/api/departments/store", {
          params: { t: Date.now() },
        });

        setDepartments(Array.isArray(data) ? data : []);
      } catch (err) {
        setDepartmentError(
          err.response?.data?.message ||
            err.message ||
            "Error cargando departamentos"
        );
      } finally {
        setDepartmentLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  const currentCategory = useMemo(() => {
    return categories.find((cat) => cat.slug === categorySlug);
  }, [categories, categorySlug]);

  const currentCategoryDepartments = useMemo(() => {
    if (!currentCategory?._id) return [];

    return departments.filter((dep) => {
      const depCategoryId =
        typeof dep.category === "object" ? dep.category?._id : dep.category;

      return String(depCategoryId) === String(currentCategory._id);
    });
  }, [departments, currentCategory]);

  const currentDepartment = useMemo(() => {
    if (!departmentSlug) return null;

    return currentCategoryDepartments.find(
      (dep) => dep.slug === departmentSlug
    );
  }, [currentCategoryDepartments, departmentSlug]);

  const pageTitle = currentDepartment?.name || currentCategory?.name || "";
  const pageDescription =
    currentDepartment?.description || currentCategory?.description || "";

  const basePath = currentDepartment
    ? `/categorias/${currentCategory.slug}/departamento/${currentDepartment.slug}`
    : currentCategory
      ? `/categorias/${currentCategory.slug}`
      : "";

  const isLoadingPage = loading || departmentLoading;

  return (
    <>
      <Header />

      <main className="page-with-footer catalog-products-page">
        {isLoadingPage ? (
          <Loading />
        ) : error ? (
          <Message variant="alert-danger">{error}</Message>
        ) : departmentError ? (
          <Message variant="alert-danger">{departmentError}</Message>
        ) : !currentCategory ? (
          <Message variant="alert-info">No se encontró esta categoría.</Message>
        ) : (
          <>
            <BreadcrumbNav
              items={[
                {
                  label: currentCategory.name,
                  to: currentDepartment
                    ? `/categorias/${currentCategory.slug}`
                    : undefined,
                },
                currentDepartment && {
                  label: currentDepartment.name,
                },
              ]}
            />

            <section className="catalog-products-layout">
              <div className="site-shell">
                <div className="site-shell-inner">
                  <div className="catalog-products-grid-layout">
                    <aside className="catalog-products-sidebar">
                      <CategoryAccordionNav
                        categories={categories}
                        departments={departments}
                        currentCategorySlug={categorySlug}
                        currentDepartmentSlug={departmentSlug}
                      />
                    </aside>

                    <div className="catalog-products-content">
                      <ShopSection
                        categoryId={currentCategory._id}
                        departmentId={currentDepartment?._id || ""}
                        categoryName={pageTitle}
                        categoryDescription={pageDescription}
                        departmentName={currentDepartment?.name || ""}
                        pagenumber={pageNumber}
                        basePath={basePath}
                        isCategoryMode={true}
                        isDepartmentMode={!!currentDepartment}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </main>

      <Footer />
    </>
  );
};

export default CatalogProductsPage;